import { Popover } from '@mui/material';
import styled from 'styled-components';

export const Header = styled.div<{ $expanded?: boolean }>`
  display: flex;
  width: 100%;
  padding: 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: ${({ $expanded }) => ($expanded ? '0px 8px 0px 0px' : '0px 8px 8px 0px')};
  border-bottom: ${({ $expanded, theme }) => ($expanded ? `1px solid ${theme.palette.grey[300]}` : '')};
  background: ${({ theme }) => theme.palette.grey[100]};

  p {
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0.17px;
    margin: 0;
    padding: 0;
  }
`;

export const FixedLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.17px;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const StyledPopover = styled(Popover)`
  box-shadow: none;
  border: none;
  border-radius: 8px;
`;
